export enum CurrentUnit {
    A,
    IIn
}
